import { render, staticRenderFns } from "./InventoryAdvancePaymentStateTransitionCommentFormDialog.vue?vue&type=template&id=a316ff06&"
import script from "./InventoryAdvancePaymentStateTransitionCommentFormDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentStateTransitionCommentFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports